import * as React from "react";
import { createLucideIcon, type LucideProps } from "lucide-react";

const MCPIcon = createLucideIcon("MCP", [
  [
    "path",
    {
      d: "M6 80.9117L73.8822 13.0294C83.255 3.65685 98.451 3.65685 107.823 13.0294C117.196 22.4019 117.196 37.598 107.823 46.9706L56.5581 98.2359",
      stroke: "currentColor",
      strokeWidth: "12",
      strokeLinecap: "round",
      key: "path-0",
    },
  ],
  [
    "path",
    {
      d: "M57.2652 97.5289L107.823 46.9706C117.196 37.598 132.392 37.598 141.765 46.9706L142.118 47.324C151.491 56.6966 151.491 71.8926 142.118 81.2651L80.7248 142.659C77.6006 145.783 77.6006 150.848 80.7248 153.972L93.331 166.579",
      stroke: "currentColor",
      strokeWidth: "12",
      strokeLinecap: "round",
      key: "path-1",
    },
  ],
  [
    "path",
    {
      d: "M90.853 30L40.6482 80.2046C31.2756 89.5769 31.2756 104.773 40.6482 114.146C50.0208 123.518 65.2167 123.518 74.5893 114.146L124.794 63.9411",
      stroke: "currentColor",
      strokeWidth: "12",
      strokeLinecap: "round",
      key: "path-2",
    },
  ],
]) as any;

export const MCP = React.forwardRef<SVGSVGElement, LucideProps>(
  ({ className = "lucide-logo", viewBox = "0 0 156 173", ...props }, ref) =>
    React.createElement(MCPIcon, {
      ref,
      className,
      viewBox,
      ...props,
    }),
) as any;

MCP.displayName = "MCP";
